import React, { useState, useEffect } from "react";
import { auth } from './fire'
import Login from './Login'
import Hero from './Hero'

function App() {

  const [searchText, setSearchText] = useState('Apple');

  const [user, setUser] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('')
  const [emailError, setEmailError] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [hasAccount, setHasAccount] = useState(false);


  const onSearchChange = (e) => {
    setSearchText(e.target.value)
  }

  const clearInputs = () => {
    setEmail('')
    setPassword('');
  }

  const clearErrors = () => {
    setEmailError('');
    setPasswordError('');
  }


  const handleLogin = () => {
    clearErrors();

    auth
      .signInWithEmailAndPassword(email, password)
      .catch(err => {
        switch (err.code) {
          case "auth/invalid-email":
          case "auth/user-disabled":
          case "auth/user-not-found":
            setEmailError(err.message);
            break;
          case "auth/wrong-password":
            setPasswordError(err.message);
            break;
          default:
        }
      })
  }


  const handleSignup = () => {
    clearErrors();

    auth
      .createUserWithEmailAndPassword(email, password)
      .catch(err => {
        switch (err.code) {
          case "auth/email-already-in-use":
          case "auth/invalid-email":
            setEmailError(err.message);
            break;
          case "auth/weak-password":
            setPasswordError(err.message);
            break;
          default:
        }
      })
  }

  const handleLogout = () => {
    localStorage.removeItem("userAvailable");
    auth.signOut();
  };

  const authListener = () => {
    auth.onAuthStateChanged(user => {
      if (user) {
        clearInputs();
        localStorage.setItem("userAvailable", "true");
        setUser(user)
      }
      else setUser('')
    })
  }

  useEffect(() => {
    authListener();
  }, [])

  const localUser = localStorage.getItem("userAvailable")

  return (
    <div className="App">
      {
        localUser === "true" ?
          <Hero handleLogout={handleLogout} onSearchChange={onSearchChange} searchText={searchText} />
          : (
            <Login email={email} setEmail={setEmail}
              password={password} setPassword={setPassword}
              handleLogin={handleLogin}
              handleSignup={handleSignup}
              hasAccount={hasAccount}
              setHasAccount={setHasAccount}
              emailError={emailError}
              passwordError={passwordError}
            />
          )
      }



    </div>
  );
}

export default App;
